import React, { useEffect, useRef, useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import parse from 'html-react-parser';
import benefits from './benefits.json';
import MembershipCards from './MembershipCards';
import check from './assets/check.svg';
import silver from './assets/silver.svg';
import gold from './assets/gold.svg';
import platinum from './assets/platinum.svg';
import diamond from './assets/diamond.svg';
import './style.scss';

const statusIcons = { silver, gold, platinum, diamond };
const pageTitle = '雅高心悦界-会员礼遇';

function BenefitValue({ value }) {
  if (value.included) {
    return <img className="check" src={check} alt="享有此礼遇" width="25" height="24" />;
  }

  if (value.minimumTier) {
    return (
      <div className="card-status">
        <img className="card-status__img" src={statusIcons[value.minimumTier]} alt="" width="25" height="25" />
        <p className="card-status__text">从状态开始</p>
        <p className="card-status__text card-status__text--bold">{value.label}</p>
      </div>
    );
  }

  return value.html ? parse(value.html) : null;
}

export default function AccorBenefits() {
  const pageRef = useRef(null);
  const [tierIndex, setTierIndex] = useState(0);
  const [openGroups, setOpenGroups] = useState({ 'group-0': true });
  const [openBenefits, setOpenBenefits] = useState({});
  const tier = benefits.tiers[tierIndex];

  useEffect(() => {
    document.title = pageTitle;
    // Other routes set global .container widths; isolate this page without changing them.
    const host = pageRef.current.closest('.container');
    if (!host) return undefined;
    host.classList.add('accor-benefits-host');
    return () => host.classList.remove('accor-benefits-host');
  }, []);

  const toggleGroup = (id) => {
    setOpenGroups((current) => ({ ...current, [id]: !current[id] }));
  };

  const toggleBenefit = (id) => {
    setOpenBenefits((current) => ({ ...current, [id]: !current[id] }));
  };

  return (
    <main  ref={pageRef}>
      <h1 className="hotel-member-title">
        <img className="hotel-member-logo accor-logo" src="https://staticfile.badazhou.com/20260922/bf21c242d75859c273070e1e7c68c5d8.png" alt="" />
        <span>{pageTitle}</span>
      </h1>

      <div className="accor-benefits">
        <MembershipCards />
        <section className="advantages" id="advantages" aria-labelledby="advantages-title">
          <div className="advantages__container">
            <h2 className="advantages__title" id="advantages-title">各等级礼遇对比</h2>
            <div className="advantages__select">
              <label htmlFor="accor-status">忠诚等级：</label>{' '}
              <select
                name="status"
                id="accor-status"
                value={tier.id}
                onChange={(event) => setTierIndex(benefits.tiers.findIndex((item) => item.id === event.target.value))}
              >
                {benefits.tiers.map((item) => <option key={item.id} value={item.id}>{item.label}</option>)}
              </select>
              <span className="fs-12 c-99">（点击切换卡片）</span>
            </div>
            <table className="advantages__table" aria-label={`${tier.label}会员礼遇`}>
              <colgroup><col /><col /></colgroup>
              <thead>
                <tr>
                  <th className="advantages__th" colSpan="2" scope="colgroup">
                    <span className={`advantages__card-type ${tier.id}`}>{tier.label}</span>
                  </th>
                </tr>
              </thead>
              {benefits.groups.map((group) => (
                <React.Fragment key={group.id}>
                  <tbody className="advantages__section">
                    <tr>
                      <th colSpan="2">
                        <h3>
                          <button
                            type="button"
                            className="advantages__heading advantages__heading--3"
                            aria-expanded={!!openGroups[group.id]}
                            aria-controls={group.id}
                            onClick={() => toggleGroup(group.id)}
                          >
                            <span>{group.title}</span>
                            <DownOutlined className="advantages__chevron" aria-hidden="true" />
                          </button>
                        </h3>
                      </th>
                    </tr>
                  </tbody>
                  <tbody className="advantages__content" id={group.id} hidden={!openGroups[group.id]}>
                    {/* The public source excludes benefits reserved for signed-in Limitless members. */}
                    {group.items.filter((item) => !item.hiddenWithoutLimitless).map((item, index) => (
                      <React.Fragment key={item.id}>
                        <tr className={`advantages__line${index % 2 === 0 ? ' advantages__line--shaded' : ''}${item.isNew ? ' advantages__line--new' : ''}${openBenefits[item.id] ? ' advantages__line--open' : ''}`}>
                          <th scope="row">
                            {item.isNew && <span className="advantages__tag">new</span>}
                            <h4>
                              <button
                                type="button"
                                className="advantages__heading advantages__heading--4"
                                aria-expanded={!!openBenefits[item.id]}
                                aria-controls={`${item.id}-description`}
                                onClick={() => toggleBenefit(item.id)}
                              >
                                <span>{item.title}</span>
                                <DownOutlined className="advantages__chevron" aria-hidden="true" />
                              </button>
                            </h4>
                          </th>
                          <td className="advantages__cell">
                            <BenefitValue value={item.cells[tierIndex]} />
                          </td>
                        </tr>
                        <tr
                          className={`advantages__details${index % 2 === 0 ? ' advantages__line--shaded' : ''}${item.isNew ? ' advantages__details--new' : ''}`}
                          hidden={!openBenefits[item.id]}
                        >
                          <td colSpan="2">
                            <div
                              className="advantages__description"
                              id={`${item.id}-description`}
                              role="region"
                              aria-label={item.title}
                            >
                              {parse(item.description)}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </React.Fragment>
              ))}
            </table>
          </div>
        </section>
      </div>
    </main>
  );
}
